import { useState, useEffect } from "react";
import { Gauge } from "lucide-react";

export function DealSpeed({ dealTimes }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(id);
  }, []);

  const now = Date.now();
  const recent = dealTimes.filter((t) => now - t <= 60000);
  let cpm = 0;
  if (recent.length > 0) {
    const sessionStart = Math.min(...dealTimes);
    const elapsed = Math.min(60, Math.max((now - sessionStart) / 1000, 5));
    cpm = Math.round((recent.length / elapsed) * 60);
  }

  return (
    <div
      className="border-2 border-foreground bg-card p-4 flex items-center justify-between"
      data-testid="deal-speed"
    >
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-1">Deal Speed</div>
        <div
          className="text-3xl font-extrabold font-mono tabular-nums tracking-tighter leading-none"
          data-testid="deal-speed-value"
        >
          {cpm}
          <span className="text-xs font-medium text-muted-foreground ml-1.5 tracking-normal">
            cards/min
          </span>
        </div>
      </div>
      <Gauge className="w-8 h-8 text-muted-foreground" aria-hidden="true" />
    </div>
  );
}
